export default __webpack_public_path__ + "static/media/pexels-photo-2131828QuangNguyenVinh650.4a3b376d.jpeg";